import { useTranslation } from 'react-i18next';

interface WizardProgressProps {
  currentStep: number;
  totalSteps: number;
}

export function WizardProgress({ currentStep, totalSteps }: WizardProgressProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center gap-2 mb-6">
      {Array.from({ length: totalSteps }, (_, i) => (
        <div
          key={i}
          className={`h-2 rounded-full transition-all duration-300 ${
            i === currentStep
              ? 'w-8 bg-primary'
              : i < currentStep
                ? 'w-2 bg-primary/60'
                : 'w-2 bg-surface-3'
          }`}
          aria-label={t('wizard.progress.step', { current: i + 1, total: totalSteps })}
        />
      ))}
    </div>
  );
}
